import { ProjectAssignmentForecastUpdateRequest, AssignmentDetails } from '../../../common/Contracts';
import { AppThunk } from '../app.store';
import { RAvailUrlProvider } from '../../../common/RAvailUrlProvider';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
import { FxpHttpService } from '@fxp/fxpservices';

const urlProvider = new RAvailUrlProvider();
const httpService = FxpServiceFactory.getServiceInstance(
        FXPServiceCatalog.FxpHttpService
    ) as FxpHttpService;
export const updateCSAProjectAssignmentForecast = (
    request: ProjectAssignmentForecastUpdateRequest
): AppThunk => {
    return async dispatch => {
        const url = urlProvider.PostCSAProjectAssignmentForecastUrl();
        try{
            const response = await httpService.post(url, request,{'Content-Type': 'application/json;',});
            console.log(response);
            return response;
        }
        catch (error) {
            console.error('Error updating CSA Project Assignment Forecast:', error);
            return error;
        }
    };
}